//MAIN
import * as React from 'react';

// COMPONENTS
import Modal from '@material-ui/core/Modal';
import { Button } from '@material-ui/core';

// styles 
import './styles.scss'


const bc = 'modal'

type Props = {
  handleAction: () => void;
  openModal: boolean;
  gdpr_content: string;
}

class SimpleModal extends React.Component<Props>{

  handeLinkClick = (e: any,) => {
    const targetLink = e.target.closest('a') as HTMLAnchorElement;
    if(!targetLink) {
      return;
    } else {
      e.preventDefault();
      window.open(targetLink.href, targetLink.target);
    }
  };

  render() {
    const { openModal, handleAction, gdpr_content } = this.props;



    return (
      <div>
        <Modal
          open={openModal}
          onClose={handleAction}
        >
          <div className={bc + ' card scrollbar'}>
            <div className={bc + '__info'} contentEditable='true' onClick={this.handeLinkClick} dangerouslySetInnerHTML={{ __html: gdpr_content }} />
            <div className={bc + '__close-block'}>
              <Button variant="contained" style={{ color: 'white', background: `gray` }} color="primary" onClick={handleAction} >
                Stäng
                  </Button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}


export default SimpleModal;